import React, { FC, useEffect, useState } from 'react';
import { OptionsProps } from '~/core/dto/components/optionsDTO';

import './Options.styles.css';

const Options: FC<OptionsProps> = ( {
  options, gap, dataChanged, multiple, callback,
} ) => {

  const [ answered, setAnswered ] = useState<string>();

  const onPress = ( id: string ) => {

    if ( multiple ) {

      const selected = answered?.split( ',' ) ?? [];

      if ( selected.includes( id ) ) {

        selected.splice( selected.indexOf( id ), 1 );

      } else {

        selected.push( id );

      }

      const newAnswered = selected.join( ',' );

      setAnswered( newAnswered );
      callback?.( newAnswered );

      return;

    }

    if ( answered ) {

      return;

    }

    callback?.( id );
    setAnswered( id );

  };

  const getOptionStatus = ( id: string ) => {

    if ( ( multiple && answered?.split( ',' ).includes( id ) ) || answered === id ) {

      return ' answered';

    }

    return '';

  };

  useEffect( () => {

    setAnswered( undefined );

  }, [ dataChanged ] );

  return (
    <div className={`optionsList${multiple ? ' multiple' : ''}`} style={{ gap, justifyContent: gap ? 'center' : 'space-between' }}>
      {options.map( ( item ) => (
        <div
          onClick={() => onPress( item.id )}
          key={item.id}
          className={`cursorPointer optionItem${getOptionStatus( item.id )} ${( item.isCorrect || multiple ) ? 'correct' : 'incorrect'} ${item.className ?? ''}`}
          aria-hidden
          style={{ width: item.width, aspectRatio: item.isImage ? 1 : undefined }}
        >
          {Boolean( item.icon ) && <img className="optionIcon" src={item.icon} alt="" />}
          {item.isImage
            ? <img src={item.title} alt={item.id} /> // eslint-disable-next-line react/no-danger
            : <p dangerouslySetInnerHTML={{ __html: item.title }} />}
          {item.description && <p className="optionDescription">{item.description}</p>}
        </div>
      ) )}
    </div>
  );

};

export default Options;
